// extracted by mini-css-extract-plugin
export default {"advertDetailContactGroup":"c-o_fX","advertDetailContactGroup__header":"c-o_fY","advertDetailContactGroup__value":"c-o_fZ"};